import { ConsoleLogger } from "amazon-chime-sdk-js";
import { SDK_LOG_LEVELS } from "@core/features/video";
import { MeetingConfig } from "./types";

export const meetingConfig: MeetingConfig = {
  simulcastEnabled: true,
  logger: new ConsoleLogger("PollinatorVideo", SDK_LOG_LEVELS.warn),
};

export default meetingConfig;
